import gql from "graphql-tag";

const imageFields = `id
alternativeText
url
formats`;

export const GET_CMS_BY_SLUG = gql`
  query GET_CMS_BY_SLUG($countryCode: String!, $slug: String!) {
    pages(
      where: { countries: { twoLetterCode: $countryCode }, slug: $slug, published: true }
      sort: "publicationDate:desc"
    ) {
      id
      title
      messageWA
      meta{
        id
        seo{
          id
          description
          index
          keywords
          thumbnail{
            ${imageFields}
          }
        }
      }
      content {
        __typename

        ... on ComponentPageSectionHeading {
          id
          published
          title
          subtitle
        }

        ... on ComponentPageHeader {
          id
          published
          description
          title
          data
          buttonIsScroll
          contactForm {
            id
            published
            title
            subtitle
            description
            sectionTitle
            sectionSubtitle
            buttonText
            subject
            emailTo
            emailFrom
            parent
            submissionSuccessText
            image{
              ${imageFields}
            }
          }
          packageSelection {
            images{
              ${imageFields}
            }
            items{
              text
              title
              subtitle
            }
          }
          image{
            id
            desktop{
              ${imageFields}
            }
            mobile{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageJsonData {
          id
          title
          data
        }
        ... on ComponentPageNewService {
          id
          published
          title
          linkText
          linkUrl
          linkTextMobile
          linkUrlMobile
        }
        ... on ComponentPageSection {
          id
          published
          sectionType
          subtitle
          title
          description
          linkCaption
          linkText
          linkUrl
          buttonText
          image{
            ${imageFields}
          }
          list{
            id
            title
            subtitle
            content
            image{
              ${imageFields}
            }
          }
          numbered
          displayImgMobile
          buttonIsPhoneNumber
          linkTextMobile
          isShowButtonDownload
        }
        ... on ComponentPageMultipleItems {
          id
          published
          listType
          entries{
            id
            title
            content
            image{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageMinistry {
          id
          published
          image{
            ${imageFields}
          }
          alt
          text
        }
        ... on ComponentPageInlineList {
          id
          published
          list{
            id
            text
          }
          order
          information
          buttonText
          buttonLink
          buttonIsPrimary
          buttonIsPhoneNumber
          buttonIsDownloadApp
          buttonIsExternalLink
          buttonIsInternalLink
        }
        ... on ComponentPageServiceSlider {
          id
          published
          title
          subtitle
          entries{
            icon
            title
            description
            comingSoon
            image{
              ${imageFields}
            }
            page{
              slug
            }
          }
        }
        ... on ComponentPageChronicCards {
          id
          published
          sectionTitle
          bottomLine
          tabs {
            id
            title
          }
          tabCards {
            id
            package
            previewTitle
            previewImage {
              ${imageFields}
            }
            previewPrice
            previewButtonTitle
            previewCurrency
            previewLinkTitle
            previewIncludesList {
              id
              text
            }
            previewIncludesListMobile {
              id
              text
            }
            expandedTitle
            expandedPrice
            expandedCurrency
            expandedCollapse
            expandedImage {
              ${imageFields}
            }
            expandedTabs {
              id
              title
            }
            linkToExploreUrl
            linkToExploreTitle
            expandedButtonDetailsTitle
            expandedButtonDetailsLink
            expandedButtonDetailsTitleMobile
            expandedButtonDetailsLinkMobile
            expandedButtonPurchaseTitle
            expandedButtonPurchaseLink
            expandedIncludesList {
              id
              text
            }
            expandedIncludesListMobile {
              id
              text
            }
            expandedList {
              id
              title
              entries {
                id
                text
              }
            }
            schedule {
              month
              treatments {
                id
                text
              }
            }
          }
        }
        ... on ComponentPageSubtitle {
          id
          published
          title
          subtitleContent{
            id
            content
          }
        }
        ... on ComponentPagePackageModules {
          id
          published
          sectionTitle
          bottomLine
          buttonText
          buttonLink
          tabs {
            id
            title
          }
          packageCards {
            id
            package
            previewTitle
            previewImage {
              ${imageFields}
            }
            previewPrice
            previewButtonTitle
            previewCurrency
            previewLinkTitle
            previewIncludesList {
              id
              text
            }
            previewIncludesListMobile {
              id
              text
            }
            tabPackageCards {
              id 
              tabName
              expandedTitle
              priceBox {
                id
                price
                currency
                info
              }
              expandedCollapse
              expandedImage {
                ${imageFields}
              }
              linkToExploreUrl
              linkToExploreTitle
              expandedButtonDetailsTitle
              expandedButtonDetailsLink
              expandedButtonDetailsTitleMobile
              expandedButtonDetailsLinkMobile
              expandedButtonPurchaseTitle
              expandedButtonPurchaseLink
              expandedIncludesList {
                id
                text
              }
              expandedIncludesListMobile {
                id
                text
              }
              expandedList {
                id
                title
                entries {
                  id
                  text
                }
              }
            }
          }
        }
        ... on ComponentPageArticlesList {
          id
          published
          name
          onlyMobile
          blog_posts {
            id
            title
            slug
          }
        }
        ... on ComponentPageVisualStory {
          id
          published
          title
          content
          textImage
          image{
            ${imageFields}
          }
        }
        ... on ComponentPageIconTextFeature {
          id
          published
          icon {
            icon {
              ${imageFields}
            }
            header {
              ${imageFields}
            }
            description
          }
        }        
        ... on ComponentPageLocationMapView {
          id
          published
          listCountry {
            id
            name
            info
            location
          }
        }
        ... on ComponentPageHeroSlider {
          id
          published
          linkText
          linkUrl
          linkCaption
          sliders {
            id
            title
            subtitle
            description
            image {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageListMedia {
          id
          published
          type
          list {
            linkUrl
            media {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageJoinUs {
          id
          title
          subtitle
          description
          buttonText
          buttonTextMobile
          linkUrl
          list {
            title
            content
            image {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageJoinUsV2 {
          id
          header
          textParagraph
          linkUrl
          image {
            ${imageFields}
          }
        }
        ... on ComponentPageComponentSplitting {
          id
          symptomSearch {
            id
            subtitle
            title
            commonSymptoms
            featureHeader
            searchHeader
            searchLabel
            contentAlign
            searchPlaceholder
          }
          typeOfCare {
            types
            subtitle
            title
            from
            pricedisclaimer
            typeofcareitems {
              price
              listheader
              listdescription
            }
            nursepackages {
              subtitle
              title
              from
              pricedisclaimer
              typeofcareitems {
                price
                listheader
                listdescription
              }
            }
            nursebuttontitle
            nursebuttondescription
            nursebackbutton
          }
        }
        ... on ComponentPageSymptomSearch {
          id
          subtitle
          title
          commonSymptoms
          featureHeader
          searchHeader
          searchLabel
          contentAlign
          searchPlaceholder
        }
        ... on ComponentPageFeaturedQuote {
          id
          description
          author
          position
          photo {
            ${imageFields}
          }
        }
        ... on ComponentPageImageTextFlexAlign {
          id
          header
          description
          image {
            ${imageFields}
          }
          align
        }
        ... on ComponentPageHeroCall {
          id
          header
          description
          heroimage {
            ${imageFields}
          }
          callusbuttonlabel
          callusbuttonlink
          downloadtheapp {
            label
            link
          }
          featureText
          featureImage {
            ${imageFields}
          }
          featureLinearGradient
        }
        ... on ComponentPageHeroForm {
          id
          header
          description
          heroimage {
            ${imageFields}
          }
          formTitle
          formDescription
          locationText
          headerImageSection
          images {
            ${imageFields}
          }
          featureLinearGradient
          contactFormV2 {
            id
            published
            title
            subtitle
            description
            sectionTitle
            sectionSubtitle
            buttonText
            subject
            emailTo
            emailFrom
            parent
            submissionSuccessText
            chronicConditions
            dropdowntitle
            formUrl
            image{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageHomepagePress {
          id
          title
          featureAward {
            ${imageFields}
          }
          pressLogos {
            ${imageFields}
          }
        }
        ... on ComponentPageContactFormImageV2 {
          id
          title
          subtitle
          image {
            ${imageFields}
          }
          contactFormV2 {
            id
            published
            title
            subtitle
            description
            sectionTitle
            sectionSubtitle
            buttonText
            subject
            emailTo
            emailFrom
            parent
            submissionSuccessText
            chronicConditions
            dropdowntitle
            image{
              ${imageFields}
            }
          }
        }
        ... on ComponentPagePartnerShowCase {
          id
          subtitle
          title
          partneritems {
            logoImage {
              ${imageFields}
            }  
            tileImage {
              ${imageFields}
            }
            tileSubtitle
            tileTitle
            tileDesc
            author
            authorDesc
          }
        }
        ... on ComponentPageHeroFlat {
          id
          header
          description
          image {
            ${imageFields}
          }
        }
        ... on ComponentPageArticleListView {
          id
          numberOfArticlePerPage
        }
        ... on ComponentPageAmbulancePartners {
          id
          buttonText
          buttonLink
          imageList {
            id
            media {
              ${imageFields}
            }
          }
        }
        ... on ComponentPagePackageCatelog {
          subtitle
          title
          description
          linearGradient
          packageCatelogItems {
            card {
              imageCard {
                ${imageFields}
              }
              header
              description
              imagetitle
              images {
                ${imageFields}
              }
            }
            overviewsection {
              title
              overviewList
              note
            }
            detailviewsection {
              title
              detailItems
            }
            schedulesection {
              timelinemonth
              visit
              content
            }
            richtextsection
            requestbutton {
              label
              link
            }
            moreinforbutton {
              label
              link
            }
          }
        }
        ... on ComponentPageOurPartnersMini {
          id
          imageList {
            id
            media {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageImageGridSquare {
          id
          imageList {
            id
            media {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageFeaturedText {
          id
          header
          description
          image {
           ${imageFields}
          }
        }
        ... on ComponentPageTypeOfCare {
          types
          subtitle
          title
          from
          pricedisclaimer
          typeofcareitems {
            price
            listheader
            listdescription
          }
          nursepackages {
            subtitle
            title
            from
            pricedisclaimer
            typeofcareitems {
              price
              listheader
              listdescription
            }
          }
          nursebuttontitle
          nursebuttondescription
          nursebackbutton
        }
        ... on ComponentPageFaq {
          id
          faqItems {
            title
            content
          }
        }
        ... on ComponentPageMiniCta {
          id
          header
          booknow
          booknowlink
          downloadappcaption
          downloadapplink
        }
        ... on ComponentPageBlogCardsHeader {
          id
          title
          description
        }
        ... on ComponentPageDownloadAppV4 {
          id
          published
          title
          subtitle
          descriptionMobile
          listDesc {
            title
            content
            image {
              ${imageFields}
            }
          }
          list{
            id
            media{
              ${imageFields}
            }
          }
          textForSms
          downloadText
          downloadButton
          downloadLink
        }
        ... on ComponentPageProgrammeFeature {
          id
          textLeft
          imageLeft {
            ${imageFields}
          }
          list {
            title
            content
            image {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageHouseCallDoctor {
          id
          published
          title
          subtitle
          descriptionMobile
          descriptionDesktop
          textForSms
          listDescription {
            title
            content
            image {
              ${imageFields}
            }
          }
          images {
            id
            media{
              ${imageFields}
            }
          }
          downloadText
          downloadButton
          downloadLink
        }
        ... on ComponentPageInformationPanel {
          id
          simpleTextPanel {
            id
            title
            subtitle
            text
          }
          conditionsList {
            id
            title
            subtitle
            descriptionTop
            listItemTop {
              id
              text
            }
            descriptionBottom
            listItemBottom {
              id
              text
            }
          }
        }
        ... on ComponentPageBusinessPartner {
          id
          description
          list{
            id
            media{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageOurServices {
          id
          footer
          ourServices {
            cardTitle
            cardSubTitle
            cardUrl
            price
            tags {
              text
            }
            callToAction
            inputStrings {
              text
            }
            ico {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageWhyBookHouseCallDoctor {
          id
          tileImagesDesktop {
            description
            image {
              ${imageFields}
            }
          }
          tileImagesMobile {
            description
            image {
              ${imageFields}
            }
          }
          partnersDesktop {
            description
            partners {
              id
              media {
                ${imageFields}
              }
            }
          }
          partnersMobile {
            description
            partners {
             id
              media {
                ${imageFields}
              }
            }
          }
          ratings {
            stars
            description
            author
            location
          }
          description
        }
        ... on ComponentPageDynamicBookingForm {
          id
          published
          bookingFromTitle
          bookingFormDescription
          bookingFormImage {
            ${imageFields}
          }
          bottomText
          bookingService {
            package
            startTime
            endTime
            timeInterval
            bufferTimeForBooking
            formType
            useBookingForm
            bookingFormReplacementMessage
          }
          backgroundColor
          formUrl
          introHeader
          introDescription
          introImage {
            ${imageFields}
          }
          serviceImage {
            ${imageFields}
          }
        }
        ... on ComponentPageTestimonials {
          id
          published
          caseCards {
            id
            logo{
              ${imageFields}
            }
            content
            author
            location
            linkUrl
          }
        }
        ... on ComponentPageTiles {
          id
          published
          subheader
          header
          description
          tiles {
            id
            tileHeader
            tilesSubheader
            tilesDescription
            tilesLink
            tilesImage{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageHeroV4 {
          id
          published
          title
          description
          image{
            id
            desktop{
              ${imageFields}
            }
            mobile{
              ${imageFields}
            }
          }
          bottomText
          services {
            package
            startTime
            endTime
            timeInterval
            bufferTimeForBooking
            formType
          }
          formUrl
        }
        ... on ComponentPageStepScreenshots{
          id
          published
          stepType
          title
          subtitle
          description
          steps {
            id
            content
            image {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageConditionCards{
          id
          published
          title
          cards {
            id
            title
            content
            image {
              ${imageFields}
            }
          }
          caption
          information
          cta
          captionTop
        }
        ... on ComponentPageServiceRates {
          id
          published
          title
          subtitle
          description
          caption
          rates {
            id
            type
            title
            subtitle
            description
            price
          }
        }
        ... on ComponentPageBlogPostSelector {
          id
          published
          filterTag
          blogEntry{
            blog_post{
              id
              publicationDate
              title
              slug
              filterTags {
                id
                tag
              }
              meta {
                seo {
                  description
                }
              }
              header {
                id
                author
                h1
                heroImage{
                  ${imageFields}
                }
              }
            }
          }
        }
        ... on ComponentPageChronicPackages {
          id
          published
          sectionTitle
          bottomLine
          chronicPackageCards
        }
        ... on ComponentPageContactForm {
          id
          published
          title
          subtitle
          description
          sectionTitle
          sectionSubtitle
          buttonText
          subject
          emailTo
          emailFrom
          parent
          fields {
            id
            name
          }
        }
        ... on ComponentPageContactFormV2 {
          id
          published
          title
          subtitle
          description
          sectionTitle
          sectionSubtitle
          buttonText
          subject
          emailTo
          emailFrom
          parent
          submissionSuccessText
          chronicConditions
          dropdowntitle
          image{
            ${imageFields}
          }
        }
        ... on ComponentPageBusinessServiceShowcase {
          title
          subtitle
          image {
            ${imageFields}
          }
          richtext
          buttonLink
          buttonText
        }
        ... on ComponentPageSplashPage {
          imageDesktop {
            ${imageFields}
          }
          imageMobile {
            ${imageFields}
          }
        }
        ... on ComponentPageContactFormNric {
          id
          published
          title
          list {
            id
            text
          }
          buttonText
          subject
          emailTo
          emailFrom
          fields {
            id
            name
          }
        }
        ... on ComponentPageContactFormTime {
          id
          published
          title
          subtitle
          buttonText
          sectionTitle
          description
          subject
          emailTo
          emailFrom
          fields {
            id
            name
          }
        }
        ... on ComponentPageContactFormEmail {
          id
          published
          title
          subtitle
          buttonText
          description
          formTitle
          emailTo
          emailFrom
          subject
          source
          parent
          fields{
            id
            name
          }
        }
        ... on ComponentPageContactFormImage {
          id
          published
          title
          description
          agreeText
          buttonText
          emailTo
          emailFrom
          subject
          fields{
            id
            name
          }
          image{
            ${imageFields}
          }
        }
        ... on ComponentPageContactFormMensHealth {
          id
          published
          title
          subtitle
          buttonText
          description
          formTitle
          emailTo
          emailFrom
          subject
          parent
          fields{
            id
            name
          }
        }
        ... on ComponentPageSliderSection {
          id
          published
          entries {
            id
            title
            subtitle
            description
            image{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageSimpleList {
          id
          published
          list {
            id
            text
          }
        }
        ... on ComponentPageSimpleParagraphs {
          id 
          published
          title
          subtitle
          paragraphs {
            paragraph
          }
          buttonText
          buttonLink
          buttonIsPrimary
          buttonIsPhoneNumber
          buttonIsExternalLink
          buttonIsInternalLink
          order
        }
        ... on ComponentPageListShowcase {
          id
          published
          title
          subtitle
          list {
            text
            subtitle
          }
          buttonText
          image{
            ${imageFields}
          }
          numbered
        }
        ... on ComponentPagePackages {
          id
          published
          title
          subtitle
          caption
          linkText
          linkUrl
          linkTextMobile
          linkUrlMobile
          linkTextPurchase
          linkUrlPurchase
          price
          currency
          duration
          image{
            ${imageFields}
          }
          inclusion {
            id
            text
          }
          inclusionMobile {
            id
            text
          }
          details {
            id
            content
          }
          schedule {
            id
            month
            treatments{
              id
              text
            }
          }
        }
        ... on ComponentPageContent {
          id
          published
          content
        }
        ... on ComponentPageVaccinesTable {
          id
          published
          sectionTitle
          sectionSubtitle
          sectionSubtitleLinkText
          sectionSubtitleLink
          title
          subtitle
          bottomTitle
          bottomDescription
          buttonText
          buttonInfo
          bottomInfo {
            id
            title
            text
          }
          table {
            id
            rows {
              id
              cells {
                id
                content
                isHeader
                color
                isCentered
                subtitle
              }
            }
          }
          tableMobile {
            id
            rows {
              id
              cells {
                id
                content
                isHeader
                color
                isCentered
                subtitle
              }
            }
          }
        }
        ...on ComponentPageBenefitsDropdown {
          id
          published
          title
          mobileTitle
          subtitle
          image {
            ${imageFields}
          }
          list {
            id
            title
            text
          }
        }
        ...on ComponentPageHero {
          id
          published
          title
          mobileTitle
          description
          image{
            id
            desktop{
              ${imageFields}
            }
            mobile{
              ${imageFields}
            }
          }
          buttonIsScroll
          buttonIsExternal
          displayDownloadButtons
          link {
            id
            text
            path
          }
        }
        ...on ComponentPageContactFormGeneric {
          id
          published
          formType
          title
          subtitle
          buttonText
          description
          formTitle
          emailTo
          emailFrom
          subject
          parent
          fields{
            id
            name
          }
        }
        ...on ComponentPageListImages {
          id
          published
          list {
            linkUrl
            media {
              ${imageFields}
            }
          }
        }
        ...on ComponentPageDropdownDetails {
          id
          published
          title
          mobileTitle
          subtitle
          image {
            ${imageFields}
          }
          list {
            id
            title
            entries {
              id
              text
            }
            isList
            button {
              text
              path
            }
          }
        }
        ...on ComponentPageVaccinationSection {
          id
          published
          title
          description
          descriptionMobile
          bottomLine
          bottomLineMobile
          image {
            ${imageFields}
          }
          buttonLink
          buttonText
          listTitle
          list {
            id
            text
          }
        }
        ...on ComponentPageSurveySection {
          id
          published
          isImageRight
          description
          descriptionMobile
          bottomLine
          bottomLineMobile
          image {
            ${imageFields}
          }
          buttonLink
          buttonText
          listTitle
          list {
            id
            text
          }
        }
        ...on ComponentPagePrivacyPolicy {
          id
          published
          title
          date
          privacySection {
            id
            title
            hasSpacing
            privacyParagraphs {
              id
              content
              isCaption
            }
          }
        }
        ...on ComponentPageSectionList {
          id
          published
          title
          subtitle
          list {
            id
            text
            title
            subtitle
          }
          linkText
          linkUrl
        }
        ... on ComponentPageDownloadMobileApps {
          id
          published
          title
          subtitle
          text
          desktopImage{
            ${imageFields}
          }
          mobileImages{
            media {
              ${imageFields}
            }
          }
          qrCodeImage{
            ${imageFields}
          }
        }
        ... on ComponentPageMargin {
          id
          published
          height
          mobileHeight
        }
        ... on ComponentPageDropdownCards {
          id
          published
          title
          subtitle
          cards {
            id
            title
            content
            image{
              ${imageFields}
            }
            subtitle
          }
        }
        ... on ComponentPagePartnerCta {
          id
          published
          background
          title
          mobileTitle
          text
          mobileText
          linkText
          linkUrl
          linkClass
          desktopTextAlignment
          mobileTextAlignment
          tracking
        }
        ... on ComponentPageImageGridRectangular {
          id
          imageListDesktop {
            id
            media {
              ${imageFields}
            }
          }
          imageListMobile {
            id
            media {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageServiceShowcase {
          id
          published
          backgroundImage{
            ${imageFields}
          }
          frame{
            ${imageFields}
          }
          defaultImage{
            ${imageFields}
          }
          title
          subtitle
          partnersCaption
          description
          services{
            id
            icon{
              ${imageFields}
            }
            image{
              ${imageFields}
            }
            title
            subtitle
            price
            link
            mobileOrder
          }
          partners{
            id
            media{
              ${imageFields}
            }
          }
        }
        ... on ComponentPageLatestUpdates {
          id
          published
          title
          updatesTitle
          updatesCards {
            id
            title
            description
            image {
              ${imageFields}
            }
            link {
              id
              text
              path
            }
          }
        }
        ... on ComponentPageStaffShowcase {
          id
          published
          title
          description
          linkBox {
            id
            title
            link {
              text
              path
            }
          }
          imagesList {
            id
            media{
              ${imageFields}
            }
            linkUrl
          }
          cards {
            id
            title
            text
          }
        }
        ... on ComponentPageMediaMentions {
          id
          published
          items {
            id
            title
            image{
              ${imageFields}
            }
            link
          }
        }
        ... on ComponentPageTripleInfo {
          id
          published
          title
          titleMobile
          linkUrl
          linkText
          cards{
            id
            title
            contentDesktop
            contentMobile
            image {
              ${imageFields}
            }
          }
        }
        ... on ComponentPageGetApp {
          id
          published
          backgroundImage{
            ${imageFields}
          }
          image{
            ${imageFields}
          }
          title
          ratingText
          text
        }
        ... on ComponentPageCaseStudies {
          id
          published
          caseCards {
            id
            logo{
              ${imageFields}
            }
            content
            author
            location
          }
        }
        ... on ComponentPageMarquee {
          id
          published
          title
          velocity
          velocityMobile
          items{
            id
            text
            value
          }
        }
        ... on ComponentPageServiceBundles {
          id
          published
          title
          subtitle
          caption
          cards {
            id
            title
            description
            price
            priceDetails
            priceUponRequest
            link
            image {
              ${imageFields}
            }
            mobileImage {
              ${imageFields}
            }
            tags {
              id
              text
              value
            }
          }
        }
        ... on ComponentPageEntriesSection {
          id
          title
          entries {
            id
            title
            text
          }
          image {
            ${imageFields}
          }
        }
        ... on ComponentPageContentCta {
          id
          published
          title
          subtitle
          description
          image {
            ${imageFields}
          }
          buttonText
          buttonLink
        }
        ... on ComponentPagePlainRichtext {
          id
          published
          richtext
        }
        ... on ComponentPageImageShowcase {
          id
          header
          imageDesktop {
            ${imageFields}
          }
          listImageMobile {
            id
            media {
              ${imageFields}
            }
          }
          description
        }
        ... on ComponentPageDataModule {
          id
          published
          title
          tabs {
            id
            title
          }
          articlesList {
            id
            published
            blog_posts {
              id
              title
              slug
            }
          }
        }
        ... on ComponentPageFeatureSection {
          id
          published
          sectionList {
            id
            title
            subtitle
            list {
              id
              published
              text
              title
              subtitle
            }
          }
          image {
            ${imageFields}
          }
        }
         ... on ComponentPageImageRichtext {
          id
          image {
            ${imageFields}
          }
          richtext          
        }
         ... on ComponentPageLeadershipFeature {
          id
          published
          title
          subtitle
          list {
            id
            published
            title
            content
            image {
              ${imageFields}
            }
          }
        }
        ... on ComponentPagePanelsTable {
          id
          published
          title
          subtitle
          footnote
          timeDescriptionMobile
          priceDescriptionMobile
          titleMobile
          tabs {
            id
            title
          }
          panels {
            id
            table {
              id
              rows {
                id
                cells {
                  id
                  content
                }
              }
            }
          }

          mobileCards {
            id
            package
            previewTitle
            previewImage {
              ${imageFields}
            }
            previewPrice
            previewButtonTitle
            previewCurrency
            previewLinkTitle
            previewIncludesList {
              id
              text
            }
            previewIncludesListMobile {
              id
              text
            }
            tabPackageCards {
              id
              tabName
              expandedTitle
              priceBox {
                id
                price
                currency
                info
              }
              expandedCollapse
              expandedImage {
                ${imageFields}
              }
              linkToExploreUrl
              linkToExploreTitle
              expandedButtonDetailsTitle
              expandedButtonDetailsLink
              expandedButtonDetailsTitleMobile
              expandedButtonDetailsLinkMobile
              expandedButtonPurchaseTitle
              expandedButtonPurchaseLink
              expandedIncludesList {
                id
                text
              }
              expandedIncludesListMobile {
                id
                text
              }
              expandedList {
                id
                title
                entries {
                  id
                  text
                }
              }
            }
          }
        }
        ... on ComponentPageBlogCardsSection {
          id
          published
          subtitle
          title
          tabs {
            id
            title
          }
        }
        ... on ComponentPagePressroomCardsSection {
          id
          published
          tabs {
            id
            title
          }
        }
      }
    }
    pressroomArticles (
      where: { countries: { twoLetterCode: $countryCode }, slug: $slug, published: true }
      sort: "publicationDate:desc"
    ) {
      id
      title
      publicationDate
      meta {
        id
        seo {
          id
          description
          keywords
          thumbnail {
            ${imageFields}
          }
        }
      }
      header {
        id
        h1
        author
        heroImage {
          ${imageFields}
        }
        content
      }
      filterTags {
        id
        tag
      }
      blogContent {
        __typename
        ... on ComponentBlogTextBlock {
          id
          richText
        }
        ... on ComponentBlogTextImage {
          id
          Content
          Image {
            ${imageFields}
          }
        }
        ... on ComponentBlogTwoColumns {
          id
          left
          right
        }
        ... on ComponentBlogImageText {
          id
          Image {
            ${imageFields}
          }
          Content
        }
        ... on ComponentBlogReactComponent {
          id
          name
        }
        ... on ComponentBlogWideImage {
          id
          imageWide {
            ${imageFields}
          }
        }
        ... on ComponentBlogVideo {
          id
          title
          video_text
          video {
            url
          }
        }
        ... on ComponentBlogCaption {
          id
          caption
        }
        ... on ComponentBlogMiniCta{
          header
          booknow
          booknowlink
          downloadappcaption
          downloadapplink
        }
      }
    }
    posts(
      where: { countries: { twoLetterCode: $countryCode }, slug: $slug, published: true }
      sort: "publicationDate:desc"
    ) {
      id
      title
      publicationDate
      meta{
        id
        seo{
          id
          description
          keywords
          thumbnail{
            ${imageFields}
          }
        }
      }
      header {
        id
        h1
        author
        heroImage {
          ${imageFields}
        }
        content
      }
      filterTags {
        id
        tag
      }
      nextPost {
        id
        publicationDate
        slug
        header {
          h1
          heroImage {
            ${imageFields}
          }
        }
        meta{
          id
          seo{
            id
            description
            keywords
            thumbnail{
              ${imageFields}
            }
          }
        }
      }
      blogContent {
        __typename
        ... on ComponentBlogTextBlock {
          id
          richText
        }
        ... on ComponentBlogTextImage {
          id
          Content
          Image {
            ${imageFields}
          }
        }
        ... on ComponentBlogTwoColumns {
          id
          left
          right
        }
        ... on ComponentBlogImageText {
          id
          Image {
            ${imageFields}
          }
          Content
        }
        ... on ComponentBlogReactComponent {
          id
          name
        }
        ... on ComponentBlogWideImage {
          id
          imageWide {
            ${imageFields}
          }
        }
        ... on ComponentBlogVideo {
          id
          title
          video_text
          video {
            url
          }
        }
        ... on ComponentBlogCaption {
          id
          caption
        }
         ... on ComponentBlogMiniCta{
          header
          booknow
          booknowlink
          downloadappcaption
          downloadapplink
        }
      }
    }
    forms (
      where: { countries: { twoLetterCode: $countryCode }, slug: $slug }
    ) {
      id
      title
      content {
        __typename
        ... on ComponentFormJotform {
          id
          url
          title
        }
      }
    }
  }
`;
